/*
   * Проверяем, что переданный элемент — кнопка
   */
export default function isWasBtn(target) {
  if (target.nodeName.indexOf('BUTTON') === -1) {
    return false;
  }

  return !target.dataset.question;
}



// WEBPACK FOOTER //
// ./src/lib/tools/itWasBtn.js